/* eslint-disable no-undef */

const TAG = 'ROLLBAR';

const RollBar = {
  userSet(id, email) {
    try {
      Rollbar.configure({
        payload: {
          person: {
            id,
            email,
          },
        },
      });
    } catch (error) {
      console.log(TAG, 'userSet', error);
    }
  },
};

export default RollBar;
